import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM11.44 6.08L7.76 10.88C7.6 11.04 7.36 11.2 7.12 11.2C6.88 11.2 6.64 11.12 6.48 10.88L4.56 8.4C4.32 8.08 4.32 7.52 4.72 7.28C5.12 7.04 5.6 7.04 5.84 7.44L7.12 9.12L10.16 5.12C10.4 4.8 10.96 4.72 11.28 4.96C11.68 5.2 11.68 5.68 11.44 6.08Z",
		fill: "#00A179"
	})
});
export default SvgCheck;
